export const payOnlineHelper = 'Online Payment is coming soon. This feature is enabled when Online Payment is on.';
